import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';

// This has to be it's own file to avoid a circular dependency
export const briefingsStyleDropdownOptions: DropdownOptionModel[] = [
    { label: 'Briefings.formField.styles.defaultAgilityStyleOne', value: BriefingStyleStateEnum.BRIEFING_1 },
    { label: 'Briefings.formField.styles.defaultAgilityStyleTwo', value: BriefingStyleStateEnum.BRIEFING_2 },
    { label: 'Briefings.formField.styles.defaultAgilityStyleThree', value: BriefingStyleStateEnum.BRIEFING_3 },
    { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
];

export const canvasStyleDropdownOptions: DropdownOptionModel[] = [
    { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
    { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
];

